import {PricingPlan} from "../helpers/constants";
import {BudgetAvailabilityType} from "../helpers/enums";

export class SubdomainInfo {
  companyName?: string;
  pictureUrl?: string;
  tosDocumentUrl?: string;
  benefitsInfoDocument?: string;
  color1?: string;
  color2?: string;
  companyHrEmail?: string;
  companyHeaderTitle?: string;
  balanceLoadDay: number;
  mealTicketsAvailabilityInDays: number;
  tourismTicketsAvailabilityInDays: number;
  culturalTicketsAvailabilityInDays: number;
  budgetAvailabilityInDays: number;
  hasTransportBudget?: boolean;
  hasProfessionalDevelopmentBudget?: boolean;
  hasCashbackBudget = false;
  hasFlexibleBenefits = false;
  hasFixedBenefits = false;
  isSsoEnabled = false;
  signUpEnabled = false;
  loadDayType = 0;
  pricingPlan: PricingPlan;
  actualBalanceLoadDay: number;
  budgetAvailabilityType: BudgetAvailabilityType;
}
